export type CampaignQuoteTemplateSectionModel = {
  cache_key: number,
  campaign_quote_template_id: number,
  header?: string,
  hide_dates?: boolean,
  hide_prices?: boolean,
  footer?: string,
  show_subtotal?: boolean,
  sort?: number,
  locked?: boolean,
  options?: {
    hide_dates?: boolean,
    hide_prices?: boolean,
    show_subtotal?: boolean,
  },
  id: number,
  title: string,
}

export type CampaignQuoteTemplateSectionRequestOptions = {}

const state = {
  campaign_quote_template_id: undefined,
  footer: undefined,
  header: undefined,
  hide_dates: false,
  hide_prices: false,
  id: null,
  locked: false,
  options: {},
  show_subtotal: false,
  sort: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'campaign_quote_template_id' },
  { key: 'title' },
]

export default state
